module.exports = __webpack_public_path__ + "static/assets/f36d5cbad056bc5dae54130fdef5658a.png";